import React from 'react';

import LinkMore from '@app/components/UI/LinkMore/LinkMore';
import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import imagePlaceholder from '@app/images/image-placeholder.png';
import '@app/scss/components/mastheadBadge.scss';

interface MastheadBadgeProps {
	title: string;
	currentPage?: string;
	readMorePath: string;
	readMoreTitle?: string;
	imageSrc: string;
	imageAlt?: string;
	mobileSrc?: string | undefined | null;
}

const MastheadBadge: React.FC<MastheadBadgeProps> = (props) => (
	<div className="masthead masthead_badge">
		<div className="masthead-wrapper">
			<div className="masthead-wrapper-bottom" />
			<div className="masthead-body">
				<div className="masthead-body__left">
					{props.currentPage && <div className="masthead-body__top">{props.currentPage}</div>}
					<h1 className="masthead-body__title">{props.title}</h1>
					<LinkMore linkMoreCaption={props.readMoreTitle ?? 'Read more'} linkMoreHref={props.readMorePath} />
				</div>
				<CustomAvatar
					className="masthead-body__image"
					src={props.imageSrc}
					mobileSrc={props.mobileSrc}
					alt={props.imageAlt || ''}
					errorAvatar={imagePlaceholder}
					lazy={false}
					fetchPriority="high"
				/>
			</div>
		</div>
	</div>
);

export default MastheadBadge;
